export const productMocks = {
  status: "success",
  message: "조회가 완료되었습니다.",
  data: [
    {
      id: 1,
      productName: "정해영 세이브왕 기념 클로저 유니폼",
      canSale: true,
      productImage: "/images/mall/shop-sample-removebg-preview.png",
      salePercent: 12,
      originalPrice: 12000,
      sale: true,
    },
    {
      id: 2,
      productName: "삼성 라이온즈 유스 티셔츠",
      canSale: true,
      productImage: "/images/mall/samsung-tshirts-removebg-preview.png",
      salePercent: 16,
      originalPrice: 14500,
      sale: true,
    },
    {
      id: 3,
      productName: "하테케야마 포수마스크",
      canSale: true,
      productImage: "/images/mall/hatake.png",
      salePercent: 12,
      originalPrice: 25000,
      sale: true,
    },
    {
      id: 4,
      productName: "타티스가 쓰는 S3 선글라스",
      canSale: true,
      productImage: "/images/mall/tatis.png",
      salePercent: 16,
      originalPrice: 25000,
      sale: true,
    },
  ],
  timestamp: "2025-06-10T08:59:55.663019",
};
